/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Card, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { Skeleton } from "@material-ui/lab";
import * as yup from "yup";
import { useFormik } from "formik";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as apiMedici from "../../api/medici";
import * as apiServizi from "../../api/servizi";
import { icons, roles } from "../../../app/config/config";

import AsyncMediciSelect from "./components/AsyncMediciSelect";
import ServizioDettagliForm from "./components/ServizioDettagliForm";

import Swal from "sweetalert2";

const formFields = {
  description: {
    label: "Dettagli Aggiuntivi",
    placeholder: "Descrizione...",
    rows: 8,
  },
  idMedico: {
    label: "Selezionare un medico",
    placeholder: "Medico...",
    newLabel: "Aggiungi nuovo",
    newLink: "/medici/#/new",
  },
  type: {
    label: "Tipo di servizio",
    placeholder: "Servizio...",
  },
  otherType: {
    label: "Altro tipo di servizio",
    placeholder: "Servizio...",
  },
  stimaCosto: {
    label: "Stima del costo del servizio",
    placeholder: "Inserisci una cifra",
  },
  dataInizio: {
    label: "Data Inizio",
    placeholder: "",
  },
  dataFine: {
    label: "Data Fine",
    placeholder: "",
  },
  titoloEvento: {
    label: "Titolo Evento",
    placeholder: "Titolo evento...",
  },
  sede: {
    label: "Sede",
    placeholder: "Sede...",
  },
  segreteria: {
    label: "Segreteria",
    placeholder: "Segreteria...",
  },
  tipoSponsorizzazione: {
    label: "Tipo Sponsorizzazione",
    placeholder: "Tipo sponsorizzazione...",
  },
  tipoMaterialeTipografico: {
    label: "Materiale Tipografico",
    placeholder: "Seleziona materiale...",
  },
  tipoIscrizioneCongresso: {
    label: "Tipo Iscrizione/Hotel",
    placeholder: "Seleziona tipo...",
  },
};

const actionsMessages = {
  send: "Invia richiesta",
  reset: "Reset",
};

const serviziTypes = [
  {
    value: 1,
    label: "Iscrizione congresso",
  },
  {
    value: 2,
    label: "Sponsorizzazione",
  },
  {
    value: 3,
    label: "Trasferta",
  },
  {
    value: 4,
    label: "Materiale Tipografico",
  },
  {
    value: 5,
    label: "Altro",
  },
];
const otherServizioType = 5;
const descriptionByType = {
  1: "Inserisci i dati del congresso",
  2: "Inserisci i dati della sponsorizzazione",
  3: "Inserisci i dati della trasferta",
  5: "Aggiungi le informazioni di rilievo",
  4: "Aggiungi le informazioni per il materiale",
};
const infoByType = {
  0: {
    hasStimaCosto: false,
    hasMedico: false,
  },
  1: {
    hasStimaCosto: false,
    hasMedico: true,
    isMedicoNecessary: true,
  },
  2: {
    hasStimaCosto: true,
    hasMedico: true,
  },
  3: {
    hasStimaCosto: false,
    hasMedico: false,
  },
  4: {
    hasStimaCosto: false,
    hasMedico: true,
  },
  5: {
    hasStimaCosto: false,
    hasMedico: false,
  },
};

const validationSchemaBuilder = (type) =>
  yup.object({
    description: yup
      .string("Inserire una descrizione valida")
      // .required("Inserire una descrizione valida")
      .min(3, "Minimo tre caratteri")
      .max(500, "Massimo cinquecento caratteri"),
    idMedico: infoByType[type].hasMedico
      ? infoByType[type].isMedicoNecessary
        ? yup
            .number("Inserire un medico valido")
            .positive("Selezionare un medico")
            .required("Seleziona un medico")
        : yup
            .number("Inserire un medico valido")
            .moreThan(-1, "Selezionare un medico")
            .required("Seleziona un medico")
      : undefined,
    stimaCosto: infoByType[type].hasStimaCosto
      ? yup.number("Inserire un costo valido").positive("Inserire un costo positivo")
      : undefined,
    type: yup
      .number("Inserire un tipo valido")
      .positive("Selezionare un tipo")
      .required("Seleziona un tipo"),
    otherType: yup.string("Inserire un tipo di servizio valido").when("type", {
      is: otherServizioType,
      then: yup
        .string()
        .required("Inserisci un tipo di servizio")
        .min(3, "Minimo tre caratteri")
        .max(50, "Massimo cinquanta caratteri"),
    }),
    dataInizio:
      type === 1 || type === 2 || type === 3
        ? yup.string().required("Inserisci la data di inizio")
        : yup.string().notRequired(),
    dataFine:
      type === 1 || type === 2 || type === 3
        ? yup.string().required("Inserisci la data di fine")
        : yup.string().notRequired(),
    titoloEvento:
      type === 1 || type === 2
        ? yup
            .string()
            .required("Inserisci il titolo dell'evento")
            .min(3, "Minimo tre caratteri")
        : yup.string().notRequired(),
    sede:
      type === 1 || type === 2
        ? yup
            .string()
            .required("Inserisci la sede")
            .min(2, "Minimo due caratteri")
        : yup.string().notRequired(),
    segreteria:
      type === 1 || type === 2
        ? yup
            .string()
            .required("Inserisci la segreteria")
            .min(2, "Minimo due caratteri")
        : yup.string().notRequired(),
    tipoSponsorizzazione:
      type === 2
        ? yup
            .string()
            .required("Inserisci il tipo di sponsorizzazione")
            .min(2, "Minimo due caratteri")
        : yup.string().notRequired(),
    tipoMaterialeTipografico:
      type === 5
        ? yup
            .string()
            .required("Seleziona il materiale tipografico")
            .min(2, "Minimo due caratteri")
        : yup.string().notRequired(),
    tipoIscrizioneCongresso:
      type === 1
        ? yup
            .string()
            .required("Seleziona il tipo di iscrizione")
            .min(2, "Minimo due caratteri")
        : yup.string().notRequired(),
  });

const ServiziToolbar = ({ submitCallback, resetCallback, loading, ...props }) => {
  return (
    <div {...props}>
      <Button disabled={loading} onClick={submitCallback} className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {actionsMessages.send}
      </Button>
      <Button disabled={loading} onClick={resetCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>
    </div>
  );
};

export const Servizi = () => {
  const [loading, setLoading] = useState(false);
  const [medici, setMedici] = useState([]);
  const [richiestaLoading, setRichiestaLoading] = useState(false);
  const [richiestaWasSuccessful, setRichiestaWasSuccessful] = useState(false);
  const [richiestaErrors, setRichiestaErrors] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [mediciInput, setMediciInput] = useState(""); // Testo digitato dall'utente

  const initialState = {
    description: "",
    idMedico: 0,
    type: 1,
    otherType: "",
    stimaCosto: 0,
    dataInizio: "",
    dataFine: "",
    titoloEvento: "",
    sede: "",
    segreteria: "",
    tipoSponsorizzazione: "",
    tipoMaterialeTipografico: "",
    tipoIscrizioneCongresso: "",
  };

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);
  //const [schema, setSchema] = useState(validationSchemaBuilder(serviziTypes[0].value))

  const updateFromServer = () => {
    setLoading(true);
    apiMedici
      .getAll(user.authToken)
      .then((data) => {
        setMedici(
          data.map((medico) => ({
            value: medico.id,
            label: medico.fullname,
            specializzazione: medico.specializzazione,
            address: medico.address,
          }))
        );
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Errore nel caricamento dei medici",
          confirmButtonColor: "#3699ff",
          confirmButtonText: "Chiudi",
        });
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const updateFromServerByType = (searchTerm) => {
  //   setLoading(true); // Mostra lo spinner

  //   apiMedici.getByInput(user.authToken, searchTerm)
  //     .then((data) => {
  //       setMedici(
  //         data.map((medico) => ({
  //           value: medico.id,
  //           label: medico.fullname,
  //           specializzazione: medico.specializzazione,
  //           address: medico.address,
  //         }))
  //       );
  //     })
  //     .catch((err) => {
  //       alert("Errore nel caricamento dei medici");
  //     })
  //     .finally(() => {
  //       setLoading(false); // Nascondi lo spinner
  //     });
  // };

  // useEffect(() => {
  //   updateFromServer();
  // }, []);

  // useEffect(() => {
  //   if (mediciInput.length >= 3) {
  //     const timer = setTimeout(() => {
  //       updateFromServerByType(mediciInput); // Chiamata API dopo 500ms
  //     }, 500); // "Debounce": evita troppe chiamate mentre l'utente digita

  //     return () => clearTimeout(timer); // Cancella il timer se l'utente digita di nuovo
  //   } else {
  //     setMedici([]); // Se meno di 3 caratteri, svuota la lista
  //   }
  // }, [mediciInput]);

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: () => validationSchemaBuilder(formik.values.type),
    onSubmit: (values) => {
      setRichiestaLoading(true);
      let typeId;
      let type;
      for (let { value, label } of serviziTypes) {
        if (value == values["type"]) {
          typeId = value;
          type = label;
          break;
        }
      }
      if (typeId == otherServizioType) {
        type = values["otherType"];
      }
      const result = { ...values, type };
      if (!infoByType[typeId].hasMedico) {
        result["idMedico"] = 0;
      }
      if (!infoByType[typeId].hasStimaCosto) {
        result["stimaCosto"] = 0;
      }
      // Normalizza le date in formato ISO YYYY-MM-DD prima dell'invio
      const formatISODate = (val) => {
        if (!val) return null;
        const s = String(val).trim();
        // dd/mm/yyyy -> yyyy-mm-dd
        const m1 = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (m1) return `${m1[3]}-${m1[2]}-${m1[1]}`;
        // già in formato yyyy-mm-dd
        const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (m2) return s;
        // fallback parsing
        const ts = Date.parse(s);
        if (!isNaN(ts)) {
          const d = new Date(ts);
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const dd = String(d.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        }
        return null;
      };

      result["dataInizio"] = formatISODate(result["dataInizio"]);
      result["dataFine"] = formatISODate(result["dataFine"]);
      console.log(result);
      apiServizi
        .add(user.authToken, result)
        .then(() => {
          formik.handleReset();
          setRichiestaWasSuccessful(true);
          setRichiestaErrors([]);
          setRichiestaLoading(false);
          setDialogOpen(true);
        })
        .catch((e) => {
          setRichiestaWasSuccessful(false);
          setRichiestaErrors([
            e && (e.plainMessage || e.message)
              ? e.plainMessage || e.message
              : "Errore imprevisto durante l'invio della richiesta.",
          ]);
          setRichiestaLoading(false);
          setDialogOpen(true);
        });
    },
  });

  const submitRequest = (event) => {
    event.preventDefault();
    event.stopPropagation();
    formik.validateForm().then((errors) => {
      const invalidFields = Object.keys(errors);
      if (invalidFields.length > 0) {
        const touchedFields = invalidFields.reduce((touched, field) => {
          touched[field] = true;
          return touched;
        }, {});
        formik.setTouched(touchedFields);
        setRichiestaWasSuccessful(false);
        setRichiestaErrors(
          invalidFields.map((field) => {
            const fieldLabel = formFields[field] ? formFields[field].label : field;
            return `${fieldLabel}: ${errors[field]}`;
          })
        );
        setDialogOpen(true);
        return;
      }

      formik.handleSubmit();
    });
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  return (
    <>
      <Card className="card-custom gutter-b">
        <Card.Header className="border-0 py-5 row">
          <Card.Title className="float-left col-auto">
            <h3 className="font-weight-bolder text-dark">Richiedi un servizio</h3>
          </Card.Title>
          <ServiziToolbar
            submitCallback={submitRequest}
            resetCallback={formik.handleReset}
            loading={richiestaLoading}
            className="float-right col-auto"
          />
        </Card.Header>
        <Card.Body className="pt-0">
          {!loading ? (
            <Form className="row" onSubmit={submitRequest}>
              <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
                <Form.Label className="col-12">{formFields["type"].label}</Form.Label>
                <select
                  type="text"
                  name="type"
                  className={`form-control ${getInputClasses("type")}`}
                  {...formik.getFieldProps("type")}
                >
                  <option value={0}>{formFields["type"].placeholder}</option>
                  {serviziTypes.map((e, key) => (
                    <option key={key} value={e.value}>
                      {e.label}
                    </option>
                  ))}
                </select>
                {formik.touched["type"] && formik.errors["type"] ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors["type"]}</div>
                  </div>
                ) : null}
              </Form.Group>

              {formik.values.type == otherServizioType ? (
                <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
                  <Form.Label className="col-12">{formFields["otherType"].label}</Form.Label>
                  <Form.Control
                    name="otherType"
                    placeholder={formFields["otherType"].placeholder}
                    className={getInputClasses("otherType")}
                    {...formik.getFieldProps("otherType")}
                  />
                  {formik.touched["otherType"] && formik.errors["otherType"] ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors["otherType"]}</div>
                    </div>
                  ) : null}
                </Form.Group>
              ) : null}

              {/* Dettagli dinamici del servizio in base al Type */}
              <ServizioDettagliForm
                type={formik.values.type}
                formik={formik}
                getInputClasses={getInputClasses}
                formFields={formFields}
              />

              {infoByType[formik.values.type].hasMedico ? (
                <Form.Group className="col-xl-12 col-lg-12 col-sm-12">
                  <Form.Label className="col-12">
                    {formFields["idMedico"].label}
                    <Link to={formFields["idMedico"].newLink} style={{ float: "right" }}>
                      {formFields["idMedico"].newLabel}
                    </Link>
                  </Form.Label>
                  <AsyncMediciSelect name="idMedico" authToken={user.authToken} user={user} formik={formik} />
                  {/* <Select
                    name="idMedico"
                    classNamePrefix="react-select"
                    value={medici.find(
                      (m) => m.value === formik.values.idMedico
                    )}
                    onChange={(selected) => {
                      formik.setFieldValue("idMedico", selected?.value || 0);
                    }}
                    
                    onInputChange={(inputValue) => setMediciInput(inputValue)} // Aggiorna la ricerca
                    // isDisabled={mediciInput.length < 3} // Disabilita se meno di 3 caratteri
                    isLoading={loading} // Mostra spinner durante il caricamento
                    noOptionsMessage={() => 
                      mediciInput.length < 3 
                        ? "Digita almeno 3 caratteri per cercare" 
                        : "Nessun risultato trovato"
                    }

                    options={medici.map((e) => ({
                      value: e.value,
                      label: e.label, // <-- stringa!
                      specializzazione: e.specializzazione,
                      address: e.address,
                    }))}
                    formatOptionLabel={(e) => (
                      <div>
                        <div>
                          <strong>{e.label}</strong>
                        </div>
                        <div style={{ fontSize: "0.90em" }}>
                          {e.specializzazione}
                        </div>
                        <div style={{ fontSize: "0.85em" }}>{e.address}</div>
                      </div>
                    )}
                    styles={{
                      singleValue: (provided) => ({
                        ...provided,
                        margin: 0,
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        fontSize: "1rem",
                      }),
                    }}
                    components={{
                      SingleValue: ({ children }) => (
                        <div
                          style={{ padding: "8px 12px" }}
                          className="react-select__single-value"
                        >
                          {children}
                        </div>
                      ),
                    }}
                  /> */}
                  {formik.touched["idMedico"] && formik.errors["idMedico"] ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors["idMedico"]}</div>
                    </div>
                  ) : null}
                </Form.Group>
              ) : null}

              <Form.Group className="col-12">
                <Form.Label className="col-12">{formFields["description"].label}</Form.Label>
                <div className="col-12 text-muted">{descriptionByType[formik.values.type]}</div>
                <Form.Control
                  as="textarea"
                  name="description"
                  placeholder={formFields["description"].placeholder}
                  //value={description}
                  //onChange={(e) => setDescription(e.target.value)}
                  rows={formFields.description.rows}
                  style={{ resize: "none" }}
                  className={getInputClasses("description")}
                  {...formik.getFieldProps("description")}
                />
                {formik.touched["description"] && formik.errors["description"] ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors["description"]}</div>
                  </div>
                ) : null}
              </Form.Group>

              {infoByType[formik.values.type].hasStimaCosto ? (
                <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
                  <Form.Label className="col-12">{formFields["stimaCosto"].label}</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="text"
                      name="stimaCosto"
                      placeholder={formFields["stimaCosto"].placeholder}
                      className={`form-control ${getInputClasses("stimaCosto")}`}
                      {...formik.getFieldProps("stimaCosto")}
                      onInput={(e) => {
                        // checks if a string is a positive number or empty
                        let val = e.target.value.replace(",", ".").replace(/[^0-9.]/g, "");
                        const shouldWait = val.endsWith(".");
                        if (shouldWait && val.search(/\.(.*)(\.)/) >= 0) {
                          val = val.substr(0, val.length - 1);
                        }
                        const parsed = shouldWait ? NaN : parseFloat(val);
                        e.persist();
                        console.log(e, e.target.value, val, parsed);
                        if (!isNaN(parsed) && parsed >= 0) {
                          e.target.value = Math.round(parsed * 100) / 100;
                        } else {
                          e.target.value = val;
                        }
                      }}
                    />
                    €
                  </div>
                  {formik.touched["stimaCosto"] && formik.errors["stimaCosto"] ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors["stimaCosto"]}</div>
                    </div>
                  ) : null}
                </Form.Group>
              ) : null}
            </Form>
          ) : (
            <div>
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="text" />
              <Skeleton variant="rect" height={518} />
            </div>
          )}
        </Card.Body>
      </Card>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="richiesta-dialog-title"
        aria-describedby="richiesta-dialog-description"
      >
        <DialogTitle id="richiesta-dialog-title">{richiestaWasSuccessful ? "Richiesta inviata" : "Errore"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="richiesta-dialog-description" component="div">
            {richiestaWasSuccessful ? (
              <p>
                La tua richiesta è stata effettuata correttamente, puoi consultare le tue richieste nella tua sezione di{" "}
                <Link to="/status-campionatura-servizi#servizi">Riepilogo</Link>
              </p>
            ) : (
              <>
                <p>Non è stato possibile inviare la richiesta. Controlla questi dettagli:</p>
                <ul>
                  {richiestaErrors.map((error, index) => (
                    <li key={`${index}-${error}`}>{error}</li>
                  ))}
                </ul>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
